import isEmpty from 'lodash/isEmpty'
import { AuthToken, AuthTokenArgs, Customer, CustomerContext } from '@typesApp/Customer'

export const hasCognitoSession = (token?: AuthToken): boolean =>
  token !== undefined && Object.keys(token).length > 0 && Boolean(token?.accessToken)

export const buildAuthTokenArgs = (
  ecommerce: string,
  customer: Customer,
  customerContext?: CustomerContext
): AuthTokenArgs => {
  const { id, firstName, lastName, email } = customer ?? {}

  const args: AuthTokenArgs = {
    ecommerce,
    customerNumber: id,
    customerType: customerContext?.customerType === 'GUEST' ? 'GUEST' : 'REGISTERED',
  }

  if (!isEmpty(firstName) && firstName?.trim().length) args.customerFirstName = firstName.trim()
  if (!isEmpty(lastName) && lastName?.trim().length) args.customerLastName = lastName.trim()
  if (!isEmpty(email) && email?.trim().length) args.customerEmail = email.trim()

  return args
}
